<!-- Pure UI Enhancement for Consent Callback -->
<div class="callback-container">
    <!-- Decorative background elements -->
    <div class="bg-blur-circle circle-1"></div>
    <div class="bg-blur-circle circle-2"></div>

    <div class="callback-card">
        <!-- Close Button (optional but good for consistency) -->
        <button class="close-ghost" (click)="goBack()" *ngIf="isError">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M18 6L6 18M6 6L18 18"></path>
            </svg>
        </button>

        <!-- Status Visual -->
        <div class="status-visual" [ngClass]="statusClass">
            <div class="icon-ring">
                <div *ngIf="isSuccess" class="icon-success">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
                <div *ngIf="isError" class="icon-error">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </div>
                <div *ngIf="isPendingVerification && !isProcessing" class="icon-warning">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>
                <div *ngIf="isProcessing && !isPendingVerification" class="brand-loader"></div>
            </div>
        </div>

        <div class="content-text">
            <h1 class="callback-title">{{ title }}</h1>
            <p class="callback-message">{{ message }}</p>
        </div>

        <!-- Details Box -->
        <div class="callback-details"
            *ngIf="callbackParams && (callbackParams.consent_handle || callbackParams.transaction_id)">
            <div class="detail-row" *ngIf="callbackParams.consent_handle">
                <span class="label">Consent Handle</span>
                <span class="value">{{ callbackParams.consent_handle }}</span>
            </div>
            <div class="detail-row" *ngIf="callbackParams.transaction_id">
                <span class="label">Transaction ID</span>
                <span class="value">{{ callbackParams.transaction_id }}</span>
            </div>
        </div>

        <div class="action-buttons">
            <button class="prime-orange-button" (click)="checkConsentStatus()"
                *ngIf="isPendingVerification || isSuccess">
                {{ isSuccess ? 'Finalize & Go to Dashboard' : 'Check Status Now' }}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </button>

            <button class="ghost-outline-button" (click)="goBack()" *ngIf="!isSuccess">
                Return to Previous Page
            </button>
        </div>
    </div>
</div>